// import { Link } from "react-router-dom";
// import { useState } from "react";
// import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";
// import ConfirmModal from "components/common/ConfirmModal";
// import ImageViewer from "components/common/ImageViewer";
// import { getImageUrl } from "utils/imageHelper";

// export default function ArticleTable({ data = [], onDelete, onRefresh }) {
//   const [deleteId, setDeleteId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [viewerOpen, setViewerOpen] = useState(false);
//   const [viewerSrc, setViewerSrc] = useState(null);
//   const [viewerData, setViewerData] = useState(null);


//   const handleDelete = async () => {
//     try {
//       setLoading(true);
//       await onDelete(deleteId);
//       setDeleteId(null);
//       onRefresh();
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return "-";
//     const d = new Date(date);
//     return d.toLocaleDateString();
//   };

//   return (
//     <>
//       <div className="overflow-hidden rounded-xl bg-white shadow-sm">
//         <table className="w-full text-left">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Image
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Exhibitor
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Title
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Author
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Published Date
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600">
//                 Status
//               </th>
//               <th className="px-6 py-4 text-sm font-semibold text-gray-600 text-right">
//                 Actions
//               </th>
//             </tr>
//           </thead>

//           <tbody className="divide-y">
//             {data.length === 0 ? (
//               <tr>
//                 <td
//                   colSpan="6"
//                   className="px-6 py-10 text-center text-sm text-gray-500"
//                 >
//                   No articles found
//                 </td>
//               </tr>
//             ) : (
//               data.map((item) => (
//                 <tr key={item._id} className="hover:bg-gray-50 transition">

//                   <td className="px-6 py-4">
//                     {(() => {
//                       let mediaPath = null;
//                       let mediaType = null;

//                       const defaultMedia = item.default_media;

//                       if (defaultMedia) {
//                         if (defaultMedia.type === "new") {
//                           if (defaultMedia.mediaType === "image") {
//                             mediaPath = item.articleImages?.[defaultMedia.value] || null;
//                             mediaType = "image";
//                           }

//                           if (defaultMedia.mediaType === "video") {
//                             mediaPath = item.articleVideos?.[defaultMedia.value] || null;
//                             mediaType = "video";
//                           }
//                         }
//                         if (defaultMedia.type === "existing") {
//                           mediaPath = defaultMedia.value || null;
//                           mediaType = defaultMedia.mediaType;
//                         }
//                       }
//                       if (!mediaPath) {
//                         if (item.articleImages?.length > 0) {
//                           mediaPath = item.articleImages[0];
//                           mediaType = "image";
//                         } else if (item.articleVideos?.length > 0) {
//                           mediaPath = item.articleVideos[0];
//                           mediaType = "video";
//                         }
//                       }
//                       if (!mediaPath) {
//                         return (
//                           <div className="h-12 w-12 rounded-lg bg-gray-100 flex items-center justify-center text-xs text-gray-400">
//                             no media
//                           </div>
//                         );
//                       }

//                       const fullUrl = getImageUrl(mediaPath);

//                       return mediaType === "image" ? (
//                         <img
//                           src={fullUrl}
//                           alt={item.title}
//                           className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
//                           onClick={() => {
//                             setViewerData({ url: fullUrl, type: "image" });
//                             setViewerOpen(true);
//                           }}
//                         />
//                       ) : (
//                         <video
//                           src={fullUrl}
//                           className="h-12 w-12 rounded-lg object-cover border cursor-pointer"
//                           onClick={() => {
//                             setViewerData({ url: fullUrl, type: "video" });
//                             setViewerOpen(true);
//                           }}
//                         />
//                       );
//                     })()}
//                   </td>




//                   <td className="px-6 py-4 font-medium text-gray-800">
//                     {item.exhibitor_id?.title}
//                   </td>

//                   <td className="px-6 py-4 font-medium text-gray-800">
//                     {item.title}
//                   </td>

//                   <td className="px-6 py-4 text-gray-600">
//                     {item.author || "-"}
//                   </td>

//                   <td className="px-6 py-4 text-gray-600">
//                     {formatDate(item.published_date)}
//                   </td>

//                   <td className="px-6 py-4">
//                     <span
//                       className={`rounded-full px-3 py-1 text-xs font-semibold ${
//                         item.status === "active"
//                           ? "bg-green-100 text-green-700"
//                           : "bg-gray-200 text-gray-600"
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                   </td>

//                   <td className="px-6 py-4">
//                     <div className="flex justify-end gap-3">

//                       <Link
//                         to={`/admin/articles/view/${item._id}`}
//                         title="View"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-500"
//                       >
//                         <MdVisibility size={18} />
//                       </Link>

//                       <Link
//                         to={`/admin/articles/edit/${item._id}`}
//                         title="Edit"
//                         className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
//                       >
//                         <MdEdit size={18} />
//                       </Link>

//                       <button
//                         title="Delete"
//                         onClick={() => setDeleteId(item._id)}
//                         className="rounded-lg p-2 text-gray-600 hover:bg-red-50 hover:text-red-600"
//                       >
//                         <MdDelete size={18} />
//                       </button>

//                     </div>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmModal
//         open={Boolean(deleteId)}
//         title="Delete Article"
//         message="This action cannot be undone. Do you want to continue?"
//         confirmText="Delete"
//         loading={loading}
//         onConfirm={handleDelete}
//         onCancel={() => setDeleteId(null)}
//       />

//       <ImageViewer
//         open={viewerOpen}
//         onClose={() => setViewerOpen(false)}
//         src={viewerData?.url}
//         type={viewerData?.type}
//       />

//     </>
//   );
// }
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdMoreVert, MdVisibility, MdEdit, MdDelete } from "react-icons/md";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "components/common/ImageViewer";

export default function ArticleTable({
  data = [],
  startIndex = 0,
  onDelete,
  onRefresh,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  viewButton,
}) {
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerData, setViewerData] = useState(null);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleMenu = (e, rowId) => {
    e.stopPropagation();
    if (openDropdownId === rowId) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(rowId);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteId);
      setDeleteId(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "—";
    const d = new Date(date);
    return d.toLocaleDateString();
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              <th className="w-12 text-center">
                <input
                  type="checkbox"
                  className="table-checkbox"
                  onChange={onSelectAll}
                  checked={
                    data.length > 0 && selectedRows.length === data.length
                  }
                />
              </th>
              <th>Media</th>
              <th>Title</th>
              <th>Exhibitor</th>
              <th>Author</th>
              <th>Published Date</th>
              <th className="text-center">Status</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="8"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No articles found
                </td>
              </tr>
            ) : (
              data.map((item, index) => {
                const rowId = item._id || index;
                const isChecked = selectedRows.includes(rowId);
                const isMenuOpen = openDropdownId === rowId;
                const isActive =
                  item.status?.toLowerCase() === "active" ||
                  item.status === true;

                return (
                  <tr key={rowId} className="custom-table-row">
                    {/* Checkbox */}
                    <td className="custom-table-cell text-center">
                      <input
                        type="checkbox"
                        className="table-checkbox"
                        checked={isChecked}
                        onChange={() => onSelectRow && onSelectRow(rowId)}
                      />
                    </td>

                    {/* Media Thumbnail */}
                    <td className="custom-table-cell">
                      {(() => {
                        let mediaPath = null;
                        let mediaType = null;
                        const defaultMedia = item.default_media;

                        if (defaultMedia) {
                          if (defaultMedia.type === "new") {
                            if (defaultMedia.mediaType === "image") {
                              mediaPath =
                                item.articleImages?.[defaultMedia.value] || null;
                              mediaType = "image";
                            }
                            if (defaultMedia.mediaType === "video") {
                              mediaPath =
                                item.articleVideos?.[defaultMedia.value] || null;
                              mediaType = "video";
                            }
                          }
                          if (defaultMedia.type === "existing") {
                            mediaPath = defaultMedia.value || null;
                            mediaType = defaultMedia.mediaType;
                          }
                        }

                        if (!mediaPath) {
                          if (item.articleImages?.length > 0) {
                            mediaPath = item.articleImages[0];
                            mediaType = "image";
                          } else if (item.articleVideos?.length > 0) {
                            mediaPath = item.articleVideos[0];
                            mediaType = "video";
                          }
                        }

                        if (!mediaPath) {
                          return (
                            <span style={{ fontSize: "10px", color: "#d1d5db" }}>
                              No media
                            </span>
                          );
                        }

                        const fullUrl = getImageUrl(mediaPath);

                        return mediaType === "image" ? (
                          <img
                            src={fullUrl}
                            alt={item.title}
                            className="table-logo cursor-pointer"
                            onClick={() => {
                              setViewerData({ url: fullUrl, type: "image" });
                              setViewerOpen(true);
                            }}
                          />
                        ) : (
                          <video
                            src={fullUrl}
                            className="table-logo cursor-pointer"
                            onClick={() => {
                              setViewerData({ url: fullUrl, type: "video" });
                              setViewerOpen(true);
                            }}
                          />
                        );
                      })()}
                    </td>

                    {/* Title */}
                    <td className="custom-table-cell font-medium">
                      {item.title || "N/A"}
                    </td>

                    {/* Exhibitor */}
                    <td className="custom-table-cell">
                      {item.exhibitor_id?.title || "—"}
                    </td>

                    {/* Author */}
                    <td className="custom-table-cell">
                      {item.author || "—"}
                    </td>

                    {/* Published Date */}
                    <td className="custom-table-cell">
                      {formatDate(item.published_date)}
                    </td>

                    {/* Status Badge */}
                    <td className="custom-table-cell text-center">
                      <span
                        className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
                          isActive
                            ? "bg-[#dcfce7] text-[#16a34a]"
                            : "bg-[#f1f5f9] text-[#64748b]"
                        }`}
                      >
                        {isActive ? "Active" : "Inactive"}
                      </span>
                    </td>

                    {/* Actions Menu */}
                    <td className="custom-table-cell relative text-center">
                      <button
                        onClick={(e) => handleToggleMenu(e, rowId)}
                        className="action-menu-btn"
                      >
                        <MdMoreVert className="text-lg" />
                      </button>

                      {isMenuOpen && (
                        <div
                          ref={dropdownRef}
                          className={`action-dropdown-menu ${
                            openUpward ? "menu-bottom" : "menu-top"
                          }`}
                        >
                          <button
                            onClick={() => {
                              if (viewButton) viewButton(item);
                              setOpenDropdownId(null);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdVisibility className="text-base" />
                            View
                          </button>

                          <div className="action-dropdown-divider" />

                          <Link
                            to={`/admin/articles/edit/${item._id}`}
                            onClick={() => setOpenDropdownId(null)}
                            className="action-dropdown-item"
                          >
                            <MdEdit className="text-base" />
                            Edit
                          </Link>

                          <div className="action-dropdown-divider" />

                          <button
                            onClick={() => {
                              setDeleteId(item._id);
                              setOpenDropdownId(null);
                            }}
                            className="action-dropdown-item"
                          >
                            <MdDelete className="text-base" />
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteId)}
        title="Delete Article"
        message="This action cannot be undone. Do you want to continue?"
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />

      {/* Media Viewer Modal */}
      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerData?.url}
        type={viewerData?.type}
      />
    </>
  );
}